module.exports = __webpack_public_path__ + "static/media/cgts_icon.7ef38109.ico";